import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { TextField, Button, IconButton, InputAdornment } from "@mui/material";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import React, { useState } from "react";
import { usePostChangePasswordMutation } from "../../services/auth";
import * as Yup from "yup";
import { useFormik } from "formik";
import { showError, showToast } from "../../constants/toasts";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [changePassword, { isLoading }] = usePostChangePasswordMutation();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [oldPassword, setOldPassword] = useState<boolean>(false);
  const [cnfmPassword, setCnfmPassword] = useState<boolean>(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleClickShowPassword1 = () => {
    setCnfmPassword((prev) => !prev);
  };
  const handleMouseDownPassword1 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const [showPassword2, setShowPassword2] = React.useState(false);
  const handleClickShowPassword2 = () => {
    setShowPassword2((prev) => !prev);
  };
  const handleMouseDownPassword2 = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string()
        // .min(6,"Minimum 6 character are required")
        .required("Current password is required"),
      newPassword: Yup.string()
        .required("New password is required")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/,
          "Password must be at least 8 characters long and include 1 uppercase, 1 lowercase, and 1 special character."
        )
        .notOneOf(
          [Yup.ref("oldPassword"), null],
          "New password can't be same as old password"
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword")], "Passwords should match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      let body = {
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
        resetPassword: false,
      };

      try {
        const response = await changePassword(body).unwrap();

        if (response?.statusCode === 200) {
          showToast("Password changed successfully");
          navigate("/dashboard");
        }
      } catch (error: any) {
        console.log(error);
        showError(error?.data?.message || "");
      }
      formik.setSubmitting(false);
    },
  });

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Change Password</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span onClick={() => navigate("/manage-profile")}>
            Manage Profile
          </span>{" "}
          - Change Password
        </p>
      </div>

      <div className="cards">
        <form onSubmit={formik.handleSubmit}>
          <div className="form">
            <div className="gap_p">
              <div className="control_group w_33">
                <label>Old Password</label>
                <TextField
                  placeholder="Enter Old Password"
                  fullWidth
                  hiddenLabel
                  type={showPassword ? "text" : "password"}
                  className="text_field"
                  id="oldPassword"
                  name="oldPassword"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.oldPassword}
                  helperText={
                    formik.touched.oldPassword && formik.errors.oldPassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className="eye_btn">
                        <IconButton
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="control_group w_33">
                <label>New Password</label>
                <TextField
                  className="text_field"
                  placeholder="New Password"
                  fullWidth
                  id="newPassword"
                  name="newPassword"
                  type={cnfmPassword ? "text" : "password"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.newPassword}
                  helperText={
                    formik.touched.newPassword && formik.errors.newPassword
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className="eye_btn">
                        <IconButton
                          aria-label={
                            cnfmPassword ? "Hide password" : "Show password"
                          }
                          onClick={handleClickShowPassword1}
                          onMouseDown={handleMouseDownPassword1}
                          edge="end"
                        >
                          {cnfmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
              <div className="control_group w_33">
                <label>Confirm New Password</label>
                <TextField
                  // placeholder="Enter Confirm New Password"
                  // hiddenLabel
                  // fullWidth
                  // type={showPassword2 ? "text" : "password"}

                  className="text_field"
                  placeholder="Enter Confirm New Password"
                  fullWidth
                  id="confirmPassword"
                  name="confirmPassword"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.confirmPassword}
                  helperText={
                    formik.touched.confirmPassword &&
                    formik.errors.confirmPassword
                  }
                  type={showPassword2 ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end" className="eye_btn">
                        <IconButton
                          aria-label={
                            showPassword2 ? "Hide password" : "Show password"
                          }
                          onClick={handleClickShowPassword2}
                          onMouseDown={handleMouseDownPassword2}
                          edge="end"
                        >
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </div>
            </div>
            <div className="form_btn">
              <Button className="btn btn_primary" type="submit">
                Next
              </Button>
            </div>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default ChangePassword;
